export const destinations = [
  // 北海道 (10箇所)
  {
    id: 1,
    name: "北海道・札幌",
    region: "北海道",
    specialty: "ジンギスカン、雪まつり",
    description: "雄大な自然と美味しいグルメが楽しめる北の大地",
    emoji: "🦐",
  },
  {
    id: 2,
    name: "北海道・函館",
    region: "北海道",
    specialty: "海鮮丼、夜景",
    description: "美しい夜景と新鮮な海の幸が楽しめる港町",
    emoji: "🌃",
  },
  {
    id: 3,
    name: "北海道・小樽",
    region: "北海道",
    specialty: "小樽運河、ガラス工芸",
    description: "ロマンチックな運河とガラス工芸で有名",
    emoji: "🚢",
  },
  {
    id: 4,
    name: "北海道・旭川",
    region: "北海道",
    specialty: "旭山動物園、ラーメン",
    description: "ユニークな展示で人気の動物園がある街",
    emoji: "🐧",
  },
  {
    id: 5,
    name: "北海道・富良野",
    region: "北海道",
    specialty: "ラベンダー、メロン",
    description: "紫のラベンダー畑が美しい花の街",
    emoji: "💜",
  },
  {
    id: 6,
    name: "北海道・知床",
    region: "北海道",
    specialty: "世界遺産、流氷",
    description: "手つかずの自然が残る世界自然遺産",
    emoji: "🐻",
  },
  {
    id: 7,
    name: "北海道・釧路",
    region: "北海道",
    specialty: "勝手丼、湿原",
    description: "釧路湿原と新鮮な海鮮で有名",
    emoji: "🦢",
  },
  {
    id: 8,
    name: "北海道・帯広",
    region: "北海道",
    specialty: "豚丼、十勝スイーツ",
    description: "十勝平野の恵みと美味しいスイーツ",
    emoji: "🐷",
  },
  {
    id: 9,
    name: "北海道・稚内",
    region: "北海道",
    specialty: "利尻昆布、日本最北端",
    description: "日本最北端の地、宗谷岬がある街",
    emoji: "🧭",
  },
  {
    id: 10,
    name: "北海道・洞爺湖",
    region: "北海道",
    specialty: "温泉、洞爺湖",
    description: "美しい湖と温泉が楽しめるリゾート地",
    emoji: "🌋",
  },

  // 東北 (21箇所)
  {
    id: 11,
    name: "青森・弘前",
    region: "東北",
    specialty: "りんご、ねぶた祭り",
    description: "美しい桜で有名な弘前城がある街",
    emoji: "🍎",
  },
  {
    id: 12,
    name: "青森・青森市",
    region: "東北",
    specialty: "ねぶた祭り、帆立",
    description: "勇壮なねぶた祭りで全国に知られる",
    emoji: "🎭",
  },
  {
    id: 13,
    name: "青森・八戸",
    region: "東北",
    specialty: "せんべい汁、朝市",
    description: "新鮮な海の幸と朝市で有名",
    emoji: "🐟",
  },
  {
    id: 14,
    name: "岩手・平泉",
    region: "東北",
    specialty: "わんこそば、中尊寺",
    description: "平安時代の文化が息づく世界遺産の町",
    emoji: "⛩️",
  },
  {
    id: 15,
    name: "岩手・盛岡",
    region: "東北",
    specialty: "冷麺、南部鉄器",
    description: "伝統工芸と美味しい麺料理の街",
    emoji: "🍜",
  },
  {
    id: 16,
    name: "岩手・宮古",
    region: "東北",
    specialty: "浄土ヶ浜、海産物",
    description: "美しい海岸線と新鮮な海の幸",
    emoji: "🌊",
  },
  {
    id: 17,
    name: "宮城・仙台",
    region: "東北",
    specialty: "牛タン、ずんだ餅",
    description: "杜の都として知られる東北最大の都市",
    emoji: "🥩",
  },
  {
    id: 18,
    name: "宮城・松島",
    region: "東北",
    specialty: "牡蠣、日本三景",
    description: "日本三景の一つ、美しい島々の景観",
    emoji: "🦪",
  },
  {
    id: 19,
    name: "宮城・鳴子温泉",
    region: "東北",
    specialty: "こけし、温泉",
    description: "伝統工芸こけしと名湯で知られる",
    emoji: "♨️",
  },
  {
    id: 20,
    name: "秋田・角館",
    region: "東北",
    specialty: "桜、武家屋敷",
    description: "みちのくの小京都と呼ばれる武家屋敷群",
    emoji: "🌸",
  },
  {
    id: 21,
    name: "秋田・秋田市",
    region: "東北",
    specialty: "きりたんぽ、なまはげ",
    description: "なまはげとあきたこまちで有名",
    emoji: "👹",
  },
  {
    id: 22,
    name: "秋田・田沢湖",
    region: "東北",
    specialty: "田沢湖、温泉",
    description: "日本一深い湖と美しい自然",
    emoji: "🏔️",
  },
  {
    id: 23,
    name: "山形・山寺",
    region: "東北",
    specialty: "立石寺、さくらんぼ",
    description: "立石寺で有名な自然に囲まれた霊場",
    emoji: "🍒",
  },
  {
    id: 24,
    name: "山形・山形市",
    region: "東北",
    specialty: "芋煮、花笠まつり",
    description: "花笠まつりと芋煮で有名",
    emoji: "🎪",
  },
  {
    id: 25,
    name: "山形・銀山温泉",
    region: "東北",
    specialty: "温泉、レトロ建築",
    description: "大正ロマンあふれる温泉街",
    emoji: "🏮",
  },
  {
    id: 26,
    name: "山形・蔵王",
    region: "東北",
    specialty: "樹氷、温泉",
    description: "冬の樹氷と温泉で有名なスキーリゾート",
    emoji: "⛷️",
  },
  {
    id: 27,
    name: "福島・会津若松",
    region: "東北",
    specialty: "赤べこ、ソースカツ丼",
    description: "戊辰戦争の舞台となった歴史ある城下町",
    emoji: "🏯",
  },
  {
    id: 28,
    name: "福島・いわき",
    region: "東北",
    specialty: "スパリゾート、石炭",
    description: "スパリゾートハワイアンズで有名",
    emoji: "🌺",
  },
  {
    id: 29,
    name: "福島・猪苗代湖",
    region: "東北",
    specialty: "野口英世、湖",
    description: "野口英世の故郷、美しい湖畔の街",
    emoji: "🔬",
  },
  {
    id: 30,
    name: "福島・大内宿",
    region: "東北",
    specialty: "茅葺屋根、そば",
    description: "江戸時代の宿場町の面影を残す",
    emoji: "🏘️",
  },
  {
    id: 31,
    name: "福島・五色沼",
    region: "東北",
    specialty: "五色の湖沼群、トレッキング",
    description: "神秘的な色合いの湖沼群",
    emoji: "🌈",
  },

  // 関東 (35箇所)
  {
    id: 32,
    name: "茨城・袋田の滝",
    region: "関東",
    specialty: "納豆、あんこう鍋",
    description: "日本三大名瀑の一つ、四季折々の美しさ",
    emoji: "💧",
  },
  {
    id: 33,
    name: "茨城・偕楽園",
    region: "関東",
    specialty: "梅まつり、納豆",
    description: "日本三名園の一つ、美しい梅園",
    emoji: "🌺",
  },
  {
    id: 34,
    name: "茨城・国営ひたち海浜公園",
    region: "関東",
    specialty: "ネモフィラ、コキア",
    description: "青いネモフィラの絶景スポット",
    emoji: "💙",
  },
  {
    id: 35,
    name: "栃木・日光東照宮",
    region: "関東",
    specialty: "湯波、日光彫",
    description: "徳川家康を祀る絢爛豪華な霊廟",
    emoji: "🏛️",
  },
  {
    id: 36,
    name: "栃木・華厳の滝",
    region: "関東",
    specialty: "中禅寺湖、湯波",
    description: "中禅寺湖から流れ落ちる名瀑",
    emoji: "🦌",
  },
  {
    id: 37,
    name: "栃木・鬼怒川温泉",
    region: "関東",
    specialty: "温泉、江戸ワンダーランド",
    description: "関東の奥座敷として親しまれる温泉地",
    emoji: "♨️",
  },
  {
    id: 38,
    name: "栃木・那須",
    region: "関東",
    specialty: "那須牛、高原",
    description: "皇室の御用邸がある高原リゾート",
    emoji: "🐄",
  },
  {
    id: 39,
    name: "群馬・草津温泉",
    region: "関東",
    specialty: "温泉まんじゅう、湯もみ",
    description: "日本三名泉の一つ、湯畑で有名な温泉地",
    emoji: "♨️",
  },
  {
    id: 40,
    name: "群馬・伊香保温泉",
    region: "関東",
    specialty: "石段街、温泉まんじゅう",
    description: "石段街で有名な歴史ある温泉地",
    emoji: "🪜",
  },
  {
    id: 41,
    name: "群馬・尾瀬",
    region: "関東",
    specialty: "水芭蕉、ハイキング",
    description: "「夏がくれば思い出す」水芭蕉の湿原",
    emoji: "🌸",
  },
  {
    id: 42,
    name: "埼玉・川越",
    region: "関東",
    specialty: "芋菓子、時の鐘",
    description: "小江戸として親しまれる蔵造りの街並み",
    emoji: "🏮",
  },
  {
    id: 43,
    name: "埼玉・秩父",
    region: "関東",
    specialty: "秩父夜祭、そば",
    description: "秩父夜祭で有名な山間の街",
    emoji: "🎭",
  },
  {
    id: 44,
    name: "埼玉・長瀞",
    region: "関東",
    specialty: "ライン下り、かき氷",
    description: "荒川の渓谷美と舟下りで有名",
    emoji: "🚣",
  },
  {
    id: 45,
    name: "千葉・成田山",
    region: "関東",
    specialty: "うなぎ、落花生",
    description: "成田山新勝寺で有名な参拝地",
    emoji: "🥜",
  },
  {
    id: 46,
    name: "千葉・房総半島",
    region: "関東",
    specialty: "海の幸、いちご狩り",
    description: "温暖な気候と豊かな海の幸",
    emoji: "🍓",
  },
  {
    id: 47,
    name: "千葉・銚子",
    region: "関東",
    specialty: "醤油、銚子電鉄",
    description: "醤油の街として知られる港町",
    emoji: "🚃",
  },
  {
    id: 48,
    name: "東京・浅草",
    region: "関東",
    specialty: "雷おこし、もんじゃ焼き",
    description: "江戸情緒あふれる下町文化の中心地",
    emoji: "🗼",
  },
  {
    id: 49,
    name: "東京・築地",
    region: "関東",
    specialty: "海鮮丼、寿司",
    description: "日本の台所として親しまれた市場",
    emoji: "🍣",
  },
  {
    id: 50,
    name: "東京・スカイツリー",
    region: "関東",
    specialty: "ソラマチ、江戸前グルメ",
    description: "東京の新たなシンボルタワー",
    emoji: "🗼",
  },
  {
    id: 51,
    name: "東京・渋谷",
    region: "関東",
    specialty: "ハチ公、若者文化",
    description: "若者文化の発信地、スクランブル交差点",
    emoji: "🐕",
  },
  {
    id: 52,
    name: "東京・銀座",
    region: "関東",
    specialty: "高級グルメ、ショッピング",
    description: "日本を代表する高級繁華街",
    emoji: "💎",
  },
  {
    id: 53,
    name: "神奈川・箱根",
    region: "関東",
    specialty: "温泉、寄木細工",
    description: "富士山を望む温泉リゾート地",
    emoji: "🗻",
  },
  {
    id: 54,
    name: "神奈川・鎌倉",
    region: "関東",
    specialty: "大仏、鎌倉野菜",
    description: "古都の風情が残る歴史の街",
    emoji: "🏛️",
  },
  {
    id: 55,
    name: "神奈川・江ノ島",
    region: "関東",
    specialty: "しらす丼、江島神社",
    description: "湘南を代表する観光地",
    emoji: "🏄",
  },
  {
    id: 56,
    name: "神奈川・横浜",
    region: "関東",
    specialty: "中華街、赤レンガ倉庫",
    description: "港町として発展した国際都市",
    emoji: "🏙️",
  },
  {
    id: 57,
    name: "神奈川・湘南",
    region: "関東",
    specialty: "サーフィン、海の家",
    description: "マリンスポーツのメッカ",
    emoji: "🏄",
  },
  {
    id: 58,
    name: "神奈川・小田原",
    region: "関東",
    specialty: "かまぼこ、小田原城",
    description: "戦国大名北条氏の城下町",
    emoji: "🏯",
  },

  // 中部 (40箇所)
  {
    id: 59,
    name: "新潟・越後湯沢",
    region: "中部",
    specialty: "コシヒカリ、スキー",
    description: "川端康成『雪国』の舞台となった温泉地",
    emoji: "⛷️",
  },
  {
    id: 60,
    name: "新潟・佐渡島",
    region: "中部",
    specialty: "金山、トキ",
    description: "金山とトキで有名な離島",
    emoji: "🐦",
  },
  {
    id: 61,
    name: "新潟・新潟市",
    region: "中部",
    specialty: "日本酒、米",
    description: "コシヒカリと日本酒で有名",
    emoji: "🍶",
  },
  {
    id: 62,
    name: "富山・立山",
    region: "中部",
    specialty: "ますずし、雪の大谷",
    description: "3000m級の山々と雪の大谷で有名",
    emoji: "🏔️",
  },
  {
    id: 63,
    name: "富山・五箇山",
    region: "中部",
    specialty: "合掌造り、和紙",
    description: "世界遺産の合掌造り集落",
    emoji: "🏘️",
  },
  {
    id: 64,
    name: "富山・宇奈月温泉",
    region: "中部",
    specialty: "黒部峡谷、トロッコ電車",
    description: "黒部峡谷の玄関口にある温泉地",
    emoji: "🚃",
  },
  {
    id: 65,
    name: "石川・金沢",
    region: "中部",
    specialty: "金箔、加賀料理",
    description: "兼六園で有名な加賀百万石の城下町",
    emoji: "⭐",
  },
  {
    id: 66,
    name: "石川・能登半島",
    region: "中部",
    specialty: "輪島塗、海の幸",
    description: "美しい海岸線と伝統工芸",
    emoji: "🌊",
  },
  {
    id: 67,
    name: "石川・和倉温泉",
    region: "中部",
    specialty: "温泉、加賀料理",
    description: "七尾湾に面した高級温泉地",
    emoji: "♨️",
  },
  {
    id: 68,
    name: "福井・恐竜博物館",
    region: "中部",
    specialty: "越前がに、恐竜化石",
    description: "世界有数の恐竜化石の産地",
    emoji: "🦕",
  },
  {
    id: 69,
    name: "福井・東尋坊",
    region: "中部",
    specialty: "断崖絶壁、越前がに",
    description: "荒々しい断崖絶壁の景勝地",
    emoji: "🌊",
  },
  {
    id: 70,
    name: "福井・永平寺",
    region: "中部",
    specialty: "精進料理、座禅",
    description: "曹洞宗の総本山",
    emoji: "⛩️",
  },
  {
    id: 71,
    name: "山梨・河口湖",
    region: "中部",
    specialty: "ほうとう、富士山",
    description: "富士五湖の一つ、富士山の絶景スポット",
    emoji: "🌸",
  },
  {
    id: 72,
    name: "山梨・山中湖",
    region: "中部",
    specialty: "ワカサギ釣り、富士山",
    description: "富士五湖最大の湖",
    emoji: "🐟",
  },
  {
    id: 73,
    name: "山梨・甲府",
    region: "中部",
    specialty: "ワイン、ぶどう",
    description: "武田信玄の城下町、ワインの産地",
    emoji: "🍇",
  },
  {
    id: 74,
    name: "長野・軽井沢",
    region: "中部",
    specialty: "そば、高原野菜",
    description: "避暑地として親しまれる高原リゾート",
    emoji: "🌲",
  },
  {
    id: 75,
    name: "長野・上高地",
    region: "中部",
    specialty: "山岳リゾート、清流",
    description: "穂高連峰の麓、日本屈指の山岳リゾート",
    emoji: "🏔️",
  },
  {
    id: 76,
    name: "長野・白馬",
    region: "中部",
    specialty: "スキー、そば",
    description: "北アルプスの麓、国際的スキーリゾート",
    emoji: "⛷️",
  },
  {
    id: 77,
    name: "長野・松本城",
    region: "中部",
    specialty: "国宝、そば",
    description: "現存12天守の一つ、烏城",
    emoji: "🏯",
  },
  {
    id: 78,
    name: "長野・善光寺",
    region: "中部",
    specialty: "そば、おやき",
    description: "無宗派の古刹、「一生に一度は善光寺参り」",
    emoji: "⛩️",
  },
  {
    id: 79,
    name: "岐阜・高山",
    region: "中部",
    specialty: "飛騨牛、さるぼぼ",
    description: "飛騨の小京都と呼ばれる古い町並み",
    emoji: "🏔️",
  },
  {
    id: 80,
    name: "岐阜・白川郷",
    region: "中部",
    specialty: "合掌造り、飛騨牛",
    description: "世界遺産の合掌造り集落",
    emoji: "🏘️",
  },
  {
    id: 81,
    name: "岐阜・下呂温泉",
    region: "中部",
    specialty: "温泉、飛騨牛",
    description: "日本三名泉の一つ",
    emoji: "♨️",
  },
  {
    id: 82,
    name: "静岡・熱海",
    region: "中部",
    specialty: "温泉、海の幸",
    description: "伊豆半島の玄関口にある温泉街",
    emoji: "🌊",
  },
  {
    id: 83,
    name: "静岡・伊豆半島",
    region: "中部",
    specialty: "わさび、金目鯛",
    description: "温泉と海の幸に恵まれた半島",
    emoji: "🐟",
  },
  {
    id: 84,
    name: "静岡・富士山",
    region: "中部",
    specialty: "富士宮やきそば、静岡茶",
    description: "日本最高峰、世界文化遺産",
    emoji: "🗻",
  },
  {
    id: 85,
    name: "静岡・浜松",
    region: "中部",
    specialty: "うなぎ、楽器",
    description: "うなぎパイと楽器の街",
    emoji: "🎹",
  },
  {
    id: 86,
    name: "静岡・静岡市",
    region: "中部",
    specialty: "静岡茶、駿河湾",
    description: "お茶の産地、駿河湾の恵み",
    emoji: "🍃",
  },
  {
    id: 87,
    name: "愛知・名古屋",
    region: "中部",
    specialty: "味噌カツ、ひつまぶし",
    description: "独特の食文化で知られる中部地方の中心都市",
    emoji: "🍱",
  },
  {
    id: 88,
    name: "愛知・犬山城",
    region: "中部",
    specialty: "国宝、木曽川鵜飼",
    description: "現存12天守の一つ、国宝指定",
    emoji: "🏯",
  },
  {
    id: 89,
    name: "愛知・豊田",
    region: "中部",
    specialty: "自動車、八丁味噌",
    description: "日本の自動車産業の中心地",
    emoji: "🚗",
  },

  // 近畿・関西 (28箇所)
  {
    id: 90,
    name: "三重・伊勢神宮",
    region: "関西",
    specialty: "伊勢うどん、赤福",
    description: "日本人の心のふるさと、お伊勢参り",
    emoji: "⛩️",
  },
  {
    id: 91,
    name: "三重・鳥羽",
    region: "関西",
    specialty: "真珠、海女",
    description: "真珠養殖発祥の地、海女の里",
    emoji: "🦪",
  },
  {
    id: 92,
    name: "三重・熊野古道",
    region: "関西",
    specialty: "世界遺産、熊野牛",
    description: "古代から続く聖地への道",
    emoji: "🥾",
  },
  {
    id: 93,
    name: "滋賀・彦根城",
    region: "関西",
    specialty: "近江牛、ひこにゃん",
    description: "国宝の天守閣とひこにゃんで有名",
    emoji: "🏯",
  },
  {
    id: 94,
    name: "滋賀・琵琶湖",
    region: "関西",
    specialty: "鮎、湖魚料理",
    description: "日本最大の湖、近江八景",
    emoji: "🐟",
  },
  {
    id: 95,
    name: "京都・祇園",
    region: "関西",
    specialty: "抹茶、京料理",
    description: "古き良き日本の文化が息づく古都",
    emoji: "🏛️",
  },
  {
    id: 96,
    name: "京都・嵐山",
    region: "関西",
    specialty: "竹林、湯豆腐",
    description: "竹林の小径で有名な風光明媚な地",
    emoji: "🎋",
  },
  {
    id: 97,
    name: "京都・金閣寺",
    region: "関西",
    specialty: "金閣、精進料理",
    description: "金色に輝く舎利殿で有名",
    emoji: "⭐",
  },
  {
    id: 98,
    name: "京都・清水寺",
    region: "関西",
    specialty: "清水の舞台、八つ橋",
    description: "清水の舞台で有名な古刹",
    emoji: "⛩️",
  },
  {
    id: 99,
    name: "京都・伏見",
    region: "関西",
    specialty: "日本酒、千本鳥居",
    description: "伏見稲荷大社と酒どころで有名",
    emoji: "🍶",
  },
  {
    id: 100,
    name: "大阪・道頓堀",
    region: "関西",
    specialty: "たこ焼き、お好み焼き",
    description: "食い倒れの街として有名なグルメの聖地",
    emoji: "🐙",
  },
  {
    id: 101,
    name: "大阪・大阪城",
    region: "関西",
    specialty: "串カツ、天下統一",
    description: "豊臣秀吉が築いた天下の名城",
    emoji: "🏯",
  },
  {
    id: 102,
    name: "大阪・新世界",
    region: "関西",
    specialty: "串カツ、通天閣",
    description: "レトロな雰囲気の下町グルメエリア",
    emoji: "🗼",
  },
  {
    id: 103,
    name: "大阪・USJ",
    region: "関西",
    specialty: "テーマパーク、バタービール",
    description: "ハリウッドの魔法を体験できるテーマパーク",
    emoji: "🎢",
  },
  {
    id: 104,
    name: "兵庫・神戸",
    region: "関西",
    specialty: "神戸牛、中華街",
    description: "異国情緒あふれる港町",
    emoji: "🥩",
  },
  {
    id: 105,
    name: "兵庫・姫路城",
    region: "関西",
    specialty: "白鷺城、播州そうめん",
    description: "世界遺産の白亜の名城",
    emoji: "🏯",
  },
  {
    id: 106,
    name: "兵庫・有馬温泉",
    region: "関西",
    specialty: "金泉・銀泉、炭酸せんべい",
    description: "日本三古湯の一つ、関西の奥座敷",
    emoji: "♨️",
  },
  {
    id: 107,
    name: "兵庫・淡路島",
    region: "関西",
    specialty: "玉ねぎ、鯛",
    description: "瀬戸内海最大の島、国生み神話の舞台",
    emoji: "🧅",
  },
  {
    id: 108,
    name: "奈良・東大寺",
    region: "関西",
    specialty: "柿の葉寿司、鹿せんべい",
    description: "大仏様と鹿で親しまれる古都",
    emoji: "🦌",
  },
  {
    id: 109,
    name: "奈良・春日大社",
    region: "関西",
    specialty: "万燈籠、奈良漬",
    description: "千体の石灯籠で有名な古社",
    emoji: "🏮",
  },
  {
    id: 110,
    name: "奈良・法隆寺",
    region: "関西",
    specialty: "世界最古の木造建築、三輪そうめん",
    description: "世界最古の木造建築群",
    emoji: "🏛️",
  },
  {
    id: 111,
    name: "和歌山・熊野古道",
    region: "関西",
    specialty: "梅干し、温泉",
    description: "世界遺産の熊野古道と熊野三山",
    emoji: "🥾",
  },
  {
    id: 112,
    name: "和歌山・白浜",
    region: "関西",
    specialty: "温泉、パンダ",
    description: "白い砂浜と温泉、アドベンチャーワールド",
    emoji: "🐼",
  },
  {
    id: 113,
    name: "和歌山・高野山",
    region: "関西",
    specialty: "精進料理、宿坊",
    description: "弘法大師が開いた真言宗の聖地",
    emoji: "⛩️",
  },

  // 中国 (15箇所)
  {
    id: 114,
    name: "鳥取・砂丘",
    region: "中国",
    specialty: "二十世紀梨、砂丘らっきょう",
    description: "日本最大級の砂丘が広がる絶景地",
    emoji: "🏜️",
  },
  {
    id: 115,
    name: "鳥取・大山",
    region: "中国",
    specialty: "大山どり、山菜",
    description: "中国地方最高峰、伯耆富士",
    emoji: "🏔️",
  },
  {
    id: 116,
    name: "島根・出雲大社",
    region: "中国",
    specialty: "出雲そば、しじみ",
    description: "縁結びの神様で有名な古社",
    emoji: "💕",
  },
  {
    id: 117,
    name: "島根・松江",
    region: "中国",
    specialty: "宍道湖しじみ、松江城",
    description: "水の都と呼ばれる城下町",
    emoji: "🏯",
  },
  {
    id: 118,
    name: "島根・石見銀山",
    region: "中国",
    specialty: "世界遺産、銀",
    description: "戦国時代から江戸時代の銀山遺跡",
    emoji: "⚒️",
  },
  {
    id: 119,
    name: "岡山・倉敷",
    region: "中国",
    specialty: "白桃、倉敷デニム",
    description: "美観地区の白壁が美しい歴史の街",
    emoji: "🏘️",
  },
  {
    id: 120,
    name: "岡山・岡山城",
    region: "中国",
    specialty: "きびだんご、烏城",
    description: "漆黒の外観で烏城と呼ばれる",
    emoji: "🏯",
  },
  {
    id: 121,
    name: "岡山・後楽園",
    region: "中国",
    specialty: "日本三名園、白桃",
    description: "日本三名園の一つ、岡山城を借景とする",
    emoji: "🌸",
  },
  {
    id: 122,
    name: "広島・宮島",
    region: "中国",
    specialty: "牡蠣、もみじまんじゅう",
    description: "厳島神社の鳥居で有名な風光明媚な島",
    emoji: "⛩️",
  },
  {
    id: 123,
    name: "広島・原爆ドーム",
    region: "中国",
    specialty: "お好み焼き、平和への祈り",
    description: "平和への願いを込めた世界遺産",
    emoji: "🕊️",
  },
  {
    id: 124,
    name: "広島・尾道",
    region: "中国",
    specialty: "尾道ラーメン、坂の街",
    description: "文学の街、猫の細道で有名",
    emoji: "🐱",
  },
  {
    id: 125,
    name: "山口・萩",
    region: "中国",
    specialty: "河豚、夏みかん",
    description: "幕末の志士を育んだ歴史ある城下町",
    emoji: "🌊",
  },
  {
    id: 126,
    name: "山口・秋吉台",
    region: "中国",
    specialty: "カルスト台地、秋芳洞",
    description: "日本最大のカルスト台地",
    emoji: "🕳️",
  },
  {
    id: 127,
    name: "山口・下関",
    region: "中国",
    specialty: "河豚、関門海峡",
    description: "本州最西端、河豚料理の本場",
    emoji: "🐡",
  },

  // 四国 (12箇所)
  {
    id: 128,
    name: "徳島・祖谷渓",
    region: "四国",
    specialty: "阿波踊り、すだち",
    description: "かずら橋と深い谷で知られる秘境",
    emoji: "🌉",
  },
  {
    id: 129,
    name: "徳島・鳴門",
    region: "四国",
    specialty: "鳴門わかめ、渦潮",
    description: "大鳴門橋と渦潮で有名",
    emoji: "🌀",
  },
  {
    id: 130,
    name: "徳島・阿波踊り会館",
    region: "四国",
    specialty: "阿波踊り、すだち",
    description: "400年の歴史を持つ阿波踊りの本場",
    emoji: "💃",
  },
  {
    id: 131,
    name: "香川・高松",
    region: "四国",
    specialty: "讃岐うどん、オリーブ",
    description: "うどん県として親しまれる四国の玄関口",
    emoji: "🍜",
  },
  {
    id: 132,
    name: "香川・小豆島",
    region: "四国",
    specialty: "オリーブ、そうめん",
    description: "オリーブと映画の島",
    emoji: "🫒",
  },
  {
    id: 133,
    name: "香川・こんぴらさん",
    region: "四国",
    specialty: "金刀比羅宮、うどん",
    description: "海の神様を祀る、1368段の石段",
    emoji: "⛩️",
  },
  {
    id: 134,
    name: "愛媛・道後温泉",
    region: "四国",
    specialty: "温泉、みかん",
    description: "日本最古の温泉として知られる歴史ある温泉地",
    emoji: "🍊",
  },
  {
    id: 135,
    name: "愛媛・松山城",
    region: "四国",
    specialty: "坊ちゃん団子、みかん",
    description: "現存12天守の一つ、松山のシンボル",
    emoji: "🏯",
  },
  {
    id: 136,
    name: "愛媛・しまなみ海道",
    region: "四国",
    specialty: "レモン、サイクリング",
    description: "瀬戸内海の島々を結ぶ絶景ルート",
    emoji: "🚴",
  },
  {
    id: 137,
    name: "高知・桂浜",
    region: "四国",
    specialty: "カツオのたたき、坂本龍馬",
    description: "坂本龍馬像と美しい砂浜で有名",
    emoji: "🐟",
  },
  {
    id: 138,
    name: "高知・四万十川",
    region: "四国",
    specialty: "鮎、清流",
    description: "日本最後の清流と呼ばれる",
    emoji: "🌊",
  },
  {
    id: 139,
    name: "高知・室戸岬",
    region: "四国",
    specialty: "金目鯛、ジオパーク",
    description: "太平洋に突き出した岬、世界ジオパーク",
    emoji: "🌊",
  },

  // 九州 (26箇所)
  {
    id: 140,
    name: "福岡・博多",
    region: "九州",
    specialty: "ラーメン、明太子",
    description: "九州最大の都市でグルメの宝庫",
    emoji: "🍜",
  },
  {
    id: 141,
    name: "福岡・太宰府",
    region: "九州",
    specialty: "梅ヶ枝餅、学問の神様",
    description: "菅原道真を祀る学問の神様",
    emoji: "📚",
  },
  {
    id: 142,
    name: "福岡・柳川",
    region: "九州",
    specialty: "川下り、うなぎ",
    description: "水郷の街、どんこ舟での川下り",
    emoji: "🚣",
  },
  {
    id: 143,
    name: "佐賀・有田",
    region: "九州",
    specialty: "有田焼、イカ",
    description: "400年の歴史を持つ陶磁器の里",
    emoji: "🏺",
  },
  {
    id: 144,
    name: "佐賀・嬉野温泉",
    region: "九州",
    specialty: "温泉、嬉野茶",
    description: "美肌の湯として有名な温泉地",
    emoji: "♨️",
  },
  {
    id: 145,
    name: "長崎・ハウステンボス",
    region: "九州",
    specialty: "カステラ、ちゃんぽん",
    description: "異国情緒あふれるテーマパークがある街",
    emoji: "🏰",
  },
  {
    id: 146,
    name: "長崎・平和公園",
    region: "九州",
    specialty: "平和への祈り、皿うどん",
    description: "平和への願いを込めた祈りの場",
    emoji: "🕊️",
  },
  {
    id: 147,
    name: "長崎・雲仙",
    region: "九州",
    specialty: "雲仙地獄、温泉",
    description: "活火山の温泉地、雲仙地獄",
    emoji: "🌋",
  },
  {
    id: 148,
    name: "長崎・五島列島",
    region: "九州",
    specialty: "五島うどん、教会群",
    description: "美しい教会群と透明な海",
    emoji: "⛪",
  },
  {
    id: 149,
    name: "熊本・阿蘇",
    region: "九州",
    specialty: "馬刺し、阿蘇の自然",
    description: "雄大なカルデラと温泉で有名",
    emoji: "🌋",
  },
  {
    id: 150,
    name: "熊本城",
    region: "九州",
    specialty: "熊本城、からし蓮根",
    description: "加藤清正が築いた堅固な名城",
    emoji: "🏯",
  },
];
